import React from 'react';
import styled from 'styled-components';

const Styles = styled.div`
    .cont {
        height: 75vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .loader-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
    }

    .loader {
        position: relative;
        width: 64px;
        height: 64px;
    }

    .loader-ring {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        border: 4px solid transparent;
        border-top-color: #d55353;
        animation: spin 0.9s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;
    }

    .loader-ring:nth-child(2) {
        inset: 8px;
        border-top-color: transparent;
        border-right-color: #e88;
        animation-duration: 1.3s;
        animation-direction: reverse;
    }

    .loader-ring:nth-child(3) {
        inset: 18px;
        border-top-color: #d55353;
        animation-duration: 1.7s;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    .loader-text {
        font-size: 15px;
        font-weight: 700;
        letter-spacing: 5px;
        text-transform: uppercase;
        margin: 0;
        background: linear-gradient(90deg, #d55353, #e8a0a0, #d55353);
        background-size: 200% auto;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        animation: shimmer 2s linear infinite;
    }

    @keyframes shimmer {
        0% { background-position: 0% center; }
        100% { background-position: 200% center; }
    }

    .loader-subtitle {
        font-size: 11px;
        font-weight: 400;
        color: #d55353;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin: 0;
        animation: fadeSubtitle 2s ease-in-out infinite;
    }

    @keyframes fadeSubtitle {
        0%, 100% { opacity: 0.3; }
        50% { opacity: 0.8; }
    }

    .loader-text .dot {
        display: inline-block;
        animation: blink 1.4s ease-in-out infinite;
        opacity: 0;
    }
    .loader-text .dot:nth-child(2) { animation-delay: 0.2s; }
    .loader-text .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes blink {
        0%, 80%, 100% { opacity: 0; }
        40% { opacity: 1; }
    }
`;

const LoaderSpinner = () => (
    <Styles>
        <div className="cont">
            <div className="loader-wrapper">
                <div className="loader">
                    <div className="loader-ring" />
                    <div className="loader-ring" />
                    <div className="loader-ring" />
                </div>
                <p className="loader-text ml-4">
                    Cargando
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                </p>
                <p className="loader-subtitle">Por favor espere</p>
            </div>
        </div>
    </Styles>
);

export default LoaderSpinner;
